import { render } from "./BaseSelectCheckbox.vue?vue&type=template&id=5dd958a2&ts=true"
import script from "./BaseSelectCheckbox.vue?vue&type=script&lang=ts"
export * from "./BaseSelectCheckbox.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__